import { ApiError } from '../types'

/**
 * Create redux-friendly ApiError from Error-like object thrown by most APIs.
 */
export function createApiError(e: unknown): ApiError {
  if (typeof e === 'object' && e !== null) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errorField = (e as unknown as ApiError).error || (e as any).error_details
    let errorMessage: string

    if (typeof errorField === 'string') {
      errorMessage = errorField
    } else if (errorField && typeof errorField === 'object' && 'message' in errorField) {
      errorMessage = String((errorField as Error).message)
    } else if ((e as unknown as Error).message) {
      errorMessage = (e as unknown as Error).message
    } else {
      errorMessage = String(e)
    }

    return {
      stack: (e as unknown as Error).stack,
      fields: (e as unknown as ApiError).fields,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      errorDetails: (e as unknown as ApiError).errorDetails || (e as any).error_details,
      error: errorMessage,
      quota: (e as unknown as ApiError).quota,
      status: (e as unknown as ApiError).status || 0
    }
  } else if (typeof e === 'string') {
    return { status: 0, error: e }
  } else {
    return { status: 0, error: `unknown error type: '${typeof e}'` }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isApiError(e: any): e is ApiError {
  return typeof e === 'object' && e !== null && typeof e.status === 'number' && typeof e.error === 'string'
}
